module.exports = __webpack_public_path__ + "img/pluto159.f09955a1.jpg";